import React from 'react';
import { CustomModal, DataList } from 'commons-ui';

import useSettingsActions from '../../../../useSettingsActions';
import { LIST_ENTITY_NAMES } from '../../../../../../settingsV2Constant';

// import { DEFAULT_CONFIG } from 'pages/settingsV2/userManagement/submodules/list/helper';
import { DEFAULT_CONFIG } from '../../../../userManagement/submodules/list/helper';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';

const PermissionsList: React.FC<{}> = () => {
	const { getPermissionsData, forceUpdate, setForceUpdate, turnForceUpdateOff } = useService();
	const { getActionHandler, getActionList } = useSettingsActions(makeActionHandler, makeActionList, {
		setForceUpdate
	});
	const actions = getActionList();
	return (
		<>
			<DataList
				defaults={DEFAULT_CONFIG}
				fetchData={getPermissionsData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				globalForceUpdate={forceUpdate}
				turnGlobalForceUpdateOff={turnForceUpdateOff}
				entity={LIST_ENTITY_NAMES.PERMISSIONS}
			/>
			<CustomModal />
		</>
	);
};

export default PermissionsList;
